import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";

export default function Testimonials({ items = [] }) {
  const [i, setI] = useState(0);
  const n = items.length;

  useEffect(() => {
    if (!n) return;
    const t = setInterval(() => setI((v) => (v + 1) % n), 6000);
    return () => clearInterval(t);
  }, [n]);

  if (!n) return null;
  const t = items[i];

  return (
    <section id="depoimentos" className="relative py-28 md:py-40 bg-[#050505]" data-testid="testimonials-section">
      <div className="absolute top-1/2 -translate-y-1/2 left-0 w-[400px] h-[400px] rounded-full bg-[#E31B23]/10 blur-[120px]" />
      <div className="absolute top-1/2 -translate-y-1/2 right-0 w-[400px] h-[400px] rounded-full bg-[#008CFF]/10 blur-[120px]" />

      <div className="relative max-w-[1200px] mx-auto px-6">
        <div className="mb-14 text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-[1px] w-10 bg-[#E31B23]" />
            <span className="overline">Clientes satisfeitos</span>
            <span className="h-[1px] w-10 bg-[#008CFF]" />
          </div>
          <h2 className="font-display font-black text-5xl md:text-6xl lg:text-7xl leading-[0.95]">
            <span className="text-white">O QUE </span>
            <span className="neon-red">DIZEM</span>
            <span className="text-white"> SOBRE NÓS</span>
          </h2>
        </div>

        <div className="relative rounded-3xl glass p-10 md:p-16 overflow-hidden">
          <Quote className="absolute top-6 left-6 w-16 h-16 text-white/5" />
          <AnimatePresence mode="wait">
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.5 }}
              data-testid="testimonial-card"
            >
              <div className="flex gap-1 mb-6">
                {Array.from({ length: t.rating || 5 }).map((_, k) => (
                  <Star key={k} className="w-5 h-5 fill-[#008CFF] text-[#008CFF] star-svg" />
                ))}
              </div>
              <p className="font-display text-2xl md:text-3xl lg:text-4xl leading-tight text-white">
                "{t.quote}"
              </p>
              <div className="mt-10 flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#E31B23] to-[#008CFF] flex items-center justify-center font-display font-bold text-white">
                  {t.name?.split(" ").map((p) => p[0]).slice(0, 2).join("")}
                </div>
                <div>
                  <div className="font-display font-bold text-white">{t.name}</div>
                  <div className="text-xs text-neutral-400 uppercase tracking-widest">
                    {t.role}{t.company ? ` · ${t.company}` : ""}
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="mt-10 flex items-center justify-between">
            <div className="flex gap-2">
              {items.map((_, k) => (
                <button
                  key={k}
                  onClick={() => setI(k)}
                  className={`h-[3px] transition-all ${k === i ? "w-10 bg-[#E31B23]" : "w-4 bg-white/20"}`}
                  data-testid={`testimonial-dot-${k}`}
                  aria-label={`Ir para depoimento ${k + 1}`}
                />
              ))}
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setI((v) => (v - 1 + n) % n)}
                className="p-3 rounded-full border border-white/10 hover:border-[#008CFF] transition-colors"
                data-testid="testimonial-prev"
                aria-label="Anterior"
              >
                <ChevronLeft className="w-4 h-4" />
              </button>
              <button
                onClick={() => setI((v) => (v + 1) % n)}
                className="p-3 rounded-full border border-white/10 hover:border-[#E31B23] transition-colors"
                data-testid="testimonial-next"
                aria-label="Próximo"
              >
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
